import { render, staticRenderFns } from "./StepsFourth.vue?vue&type=template&id=0ae9f192&scoped=true"
import script from "./StepsFourth.vue?vue&type=script&lang=js"
export * from "./StepsFourth.vue?vue&type=script&lang=js"
import style0 from "./StepsFourth.vue?vue&type=style&index=0&id=0ae9f192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9f192",
  null
  
)

export default component.exports